export default __webpack_public_path__ + "static/media/BookmarkLandingPage-Thumbnail.1ad36cf0.png";